export default "__VITE_ASSET__DQX9PpNR__"